import { render, staticRenderFns } from "./DeleteMailboxDialog.vue?vue&type=template&id=1bebe871&"
import script from "./DeleteMailboxDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteMailboxDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports